<template>
    <v-dialog v-model="open" max-width="600" persistent>
        <v-card class="background-2 round-card">
            <v-card-title class="pa-3">
                <p class="pl-2 pl-xl-3">Invio documenti in formato Elettronico</p>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-4 body-2">Vuoi inviare i documenti selezionati in formato Elettronico?</v-card-text>
            <v-card-text class="body-2">Elementi selezionati:  <span class="body-1 font-weight-medium">{{ selected.length }}</span></v-card-text>

            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="info" @click.native="$emit('close')">Annulla
                </v-btn>
                <v-btn text color="primary" @click.native.stop="sendEdocuments()" :loading="loading">Procedi
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
	
	export default {
		name: 'edocument-sender-button',
		props: {
            params: Object,
            selected: Array,
            selectedIds: Array,
            modelDef: String,
            open: Boolean
		},
		data() {
            return {
                loading: false,
			}
        },

        methods: {
                
            sendEdocuments() {
                let ids = this.selectedIds
                this.loading = true

                this.axios.get('send-electronic-' + this.modelDef, { params: { ids: ids}}).then(response => {
                    // get body data
                    let data = response.data
                    let snackmessage = ''
                    let snackcolor = ''
                    if(data.status == 'message' || data.message){
                        snackmessage = data.message
                        snackcolor = 'success'
                    } else{
                        snackmessage = data.message
                        snackcolor = 'warning'
                    }
                    this.$store.commit('setSnackbar', {timeout: 6000, text: snackmessage, value: true, color: snackcolor})

                    this.loading = false
                    this.$emit('close')
                    
                    if(response.data.id.length == 1) {
                        this.$eventBusUtility.goTo(this.$router, 'documents-show', response.data.id[0])
                    }
                }, response => {
                    // error callback
                    this.loading = false
                })
            },            
        },

	}
</script>

